
import { Options, Vue } from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import { formatAmoutswitchCurrency, formatPercentage, formatWithMask } from "@/utils/configuration/formatters-config";
import i18n from "@/i18n";
import store from "@/store";
import { Ratio } from "@/types";

@Options({
  components: {
    LabelAndValue,
  },
  props: ["proposal", "valueStyle", "labelStyle", "divValueStyle"],
})
export default class SummaryLease extends Vue {
  proposal?: any;
  valueStyle?: any;
  labelStyle?: any;
  divValueStyle?: any;

  get price() {
    return `${formatAmoutswitchCurrency('EUR', this.proposal.businessData.priceWTax)} `;
  }
  get monthly() {
    return `${formatAmoutswitchCurrency('EUR', this.proposal.financialPaymentWTax)} `;
  }
  get amountRefunded() {
    return !this.proposal.sumOfTotalPayments
      ? "-"
      : `${formatAmoutswitchCurrency('EUR', this.proposal.sumOfTotalPayments.amount)} `;
  }
  get duration() {
    return `${this.proposal.numberOfPaymentTerm} ` + this.durationUnit(undefined,'duration');
  }
  get tax() {
    
    return formatPercentage(this.proposal.nominalRate);
  }
        get assetState() {
    return store.state.demandModule.assetState;
  }
      get asset():any {
    return this.assetState.proposalAssets[0];
  }


  get purchasePercentage() {
    return this.proposal?.proposalAssets?.[0]?.businessData?.purchasePercentage ?? 0;
  }
/*  get residualValue() {
    return !this.proposal.residualValueAmountWTax
      ? "-"
      : `${formatWithMask(this.proposal.residualValueAmountWTax, 2)} || ${
      formatPercentage(this.purchasePercentage) 
        }`;
  }*/
  get firstPayment() {
    return !this.proposal.firstPaymentWTax
      ? "-"
      : `${formatWithMask(this.proposal.firstPaymentWTax, 2)} || ${
      formatPercentage(this.proposal.firstPaymentPercentage)
        }`;
  }

  camelSentence(str?: string) {
    return  (" " + str).toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(match, chr)
    {
      return chr.toUpperCase();
    });
  }

  get frequency() {
    return this.durationUnit('frequency').replace(/[\])[(]/g, '');
  }
  
  get offer() {
    return  store.state.summaryPanelModule?.offer ;
  }
  get gracePeriodTerms() {
    const businessDataGracePeriodTerms = this.proposal.gracePeriodDuration;
    return (
  (this.proposal.defaultNumberGracePeriodTerms ? formatWithMask(this.proposal.defaultNumberGracePeriodTerms, 2) : null) ??
  (formatWithMask(businessDataGracePeriodTerms, 2)) ?? '-'
)

  } 

  get gracePeriodTermsType() {
    return !this.proposal.gracePeriodTermsType ? "-" : this.proposal.gracePeriodTermsType
  }

  get gracePeriodTermsTax() {
    const gracePeriodRate = this.proposal.gracePeriodRate
    return (
      (this.proposal.gracePeriodTermsTax ? `${formatWithMask(this.proposal.gracePeriodTermsTax, 2)} %` : null) ??
      (gracePeriodRate !== undefined && gracePeriodRate !== null ? `${gracePeriodRate} %` : null) ?? "-"
    )
  }

  get residualAmountFormatted() {
    return this.proposal.residualValueAmountWTax
        ? formatWithMask(this.proposal.residualValueAmountWTax, 2)
        : "-";
  }

  get residualPercentageFormatted() {
    return formatPercentage(this.purchasePercentage);
  }

  get isResidualPercentageHigh() {
    return this.purchasePercentage > 60;
  }

  get globalOutstandingHT() {
    const ratios = store.state.analysisModule?.analysis?.ratios as Ratio[] | undefined;
    if (!ratios?.length) {
      return "-";
    }
    const ratio = ratios.find(
      (item) => item.ratioParam?.resourceUid === "RAT_ENCOURS"
    );
    if (ratio?.value === undefined || ratio?.value === null || ratio.value === "") {
      return "-";
    }
    const amount = Number(ratio.value);
    if (!Number.isFinite(amount)) {
      return "-";
    }
    return `${formatAmoutswitchCurrency("EUR", amount)} `;
  }

  durationUnit(type?: string, context?: any) {
  const basePath = 'main.labels.sliders';
  const duration = this.proposal.periodBetween2Installments.duration;
  const unit = this.proposal.periodBetween2Installments.unit;
  const numberOfPaymentTerm = this.proposal.numberOfPaymentTerm;

  const getLabel = (suffix: string, extraParams: object = {}) =>
    i18n.global.t(`${basePath}.${suffix}`, { ...extraParams, period2: this.camelSentence(unit) });

  const durationSuffix = (context === 'duration') 
    ? `${duration}_months.slider` 
    : `${duration}_months.slider_frequency`;

  if ([1, 3, 6, 12].includes(duration)) {
    return getLabel(durationSuffix);
  }

  const params = { duration, param2: numberOfPaymentTerm };
  if (type) {
    return getLabel('default.slider', params);
  } else {
    return i18n.global.t(`${basePath}.default.label`, { ...params, period: this.camelSentence(unit) });
  }
}


}
